import React from 'react';
import ReactDOM from 'react-dom';

import Warning from '../../utils/Warn';
import {LookupAutoQueryStore} from '../../stores/LookupStores';
import FormItemDateResolver from '../../formItem/resolver/FormItemDateResolver';
import FormItemDateDisplay from '../../formItem/display/FormItemDateDisplay';
import FormItemConst from '../../formItem/FormItemConst';

export default class AutoLookupDateEditor extends React.Component
{
	lookupStates = 
	{
		isShowed:false
	}

	constructor(props) {
		super(props);
		this.record = "";
		this.state = {inQueryGroup:false};
		this.classAlias = "AutoLookupDateEditor";
		this.unsubscribeLookupAutoQueryStore = LookupAutoQueryStore.listen(this.onLookupAutoQuery.bind(this));
	}

	
	onLookupAutoQuery(key,args)
	{
		if(this.props.lookupKey == key && this.state.inQueryGroup)
		{
			args[this.props.tableField.name] = this.record;
		}
	}

	showDateDropDown()
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		var $pickerdropdown = $("div.datepicker");
		if ($pickerdropdown.is(':visible'))
		{
			this.lookupStates.isShowed = false;
			$(this.inputField).datepicker('hide');
		}
		else
		{
			this.lookupStates.isShowed = true;
			$(this.inputField).datepicker('show');
		}
	}

	onDatePanelClose()
	{
		this.lookupStates.isShowed = false;
	}

	componentDidMount()
	{
		$(this.inputField).datepicker({
		      language: 'zh-CN',
		      autoclose: true,//选中之后自动隐藏日期选择框
		      clearBtn: true,//清除按钮
		      todayBtn: true,//今日按钮
		      todayHighlight:true,
		      format: "yyyy-mm-dd",
		      buttonImageOnly: true,
		      hide:this.onDatePanelClose.bind(this)
		  });

		 //此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
		 //不能获得焦点的比如下拉框div仍然可以使得input失去焦点
		 $(this.inputField).blur(function(event){
		 	  /*if(event.relatedTarget!=null && event.relatedTarget == this.refs.inputpicker)
		 	  {
		 	  	return;
		 	  }*/
		  	  //$(this).val("06-06");
		 });
	}

	//新框架避免增加复杂条件判断 所以该类只表示Form上FormItem
	inputFieldBlur()
	{
		if(this.lookupStates.isShowed)
			return;
		this.setFinalValue();
		this.setDisplay();
	}

	setFinalValue(value)
	{
		if(!value)
			value = $(this.inputField).val();
		if(value == "t" || value == "T")
		{
			var today = new Date();
			value = today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate();
		}
		value = FormItemDateResolver.getResult(value,false);
		if(value.indexOf("false:") == 0)
		{
			Warning.show({text:value.substr(6)});
			return false;
		}
		this.record = value;
		return true;
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			value = this.record;
		}

		value = FormItemDateDisplay.getDisplayText(value,this.props.show1970,this.props.seperator,this.props.numOfDay,this.props.numOfMonth,this.props.numOfYear);

		$(this.inputField).val(value);
	}

	onKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			//TODO 如何做自定义导航
			//e.preventDefault();
		}
		else if(e.keyCode>64&&e.keyCode<91&&e.keyCode!=84)
		{
			e.preventDefault();
		}
	}

	getInputDom(_width)
	{
		let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,fontSize:"12px"};

		if(this.state.inQueryGroup)
			return 	<input spellCheck="false" ref={ node => this.inputField = node }
		        	   type="text" className="form-control pull-right" id={"AutoLookupDateEditor"+this.props.id} style={_style}
		        	   onBlur={this.inputFieldBlur.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		else
			return 	<input spellCheck="false" ref={ node => this.inputField = node } readOnly="readonly" 
		        	   type="text" className="form-control pull-right" id={"AutoLookupDateEditor"+this.props.id} style={_style}
		        	   onBlur={this.inputFieldBlur.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		
	}

	getDownArrowButtonDom()
	{
		if(this.state.inQueryGroup)
			return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'33px',paddingLeft:'6px',paddingRight:'6px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
		else
			return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'33px',paddingLeft:'6px',paddingRight:'6px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
	}

	labelClickHandler()
	{
		this.setState({inQueryGroup:!this.state.inQueryGroup});
	}

	render()
	{
		let displayLength=this.props.displayLength;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		
		let inputdom = this.getInputDom(_width);
		let downArrowButtonDom = this.getDownArrowButtonDom();
		let labelStyle = {paddingLeft:'5px',cursor:'pointer',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		if(!this.state.inQueryGroup)
		{
			labelStyle.color = "#CFCFCF";
		}
		return (
			<div id={this.props.id} className='editorGroup' ref={node=>this.contextMenuHandler=node} style={editorStyle}>
			  <label htmlFor={"AutoLookupDateEditor"+this.props.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
			  		 {this.props.label}
			  </label>
			  <div className="input-group date">
			  	{inputdom}{downArrowButtonDom}
		      </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/autoLookup/AutoLookupDateEditor.js